import styled from "@emotion/styled";
import { fontBarlowSemiCondensed } from "@product/scmp-sdk";

import {
  StyledImage as AuthorAvatarImage,
  StyledPlaceholder as AuthorPlaceholder,
} from "~/components/author/author-avatar/styles";
import { AuthorName } from "~/components/author/author-name";
import { AuthorSocialLinks } from "~/components/author/author-social-links";
import { EntityFollowButton } from "~/components/entity-follow-button";

export const AuthorCardContainer = styled.div`
  display: grid;
  grid:
    "avatar . header-bar ." min-content
    "avatar . . ." 8px
    "avatar . name ." min-content
    "avatar . . ." 16px
    "avatar . follow-button ." min-content
    "avatar . . ." 12px
    "avatar . bio ." min-content
    "avatar . social ." min-content
    / min-content 12px auto 5px;

  ${props => props.theme.breakpoints.up("tablet")} {
    grid:
      "avatar . header-bar ." min-content
      "avatar . . ." 8px
      "avatar . name ." min-content
      "avatar . . ." 16px
      "avatar . follow-button ." min-content
      "avatar . . ." 12px
      "avatar . bio ." min-content
      "avatar . social ." min-content
      / min-content 20px auto 5px;
  }
`;

export const AvatarContainer = styled.div`
  grid-area: avatar;

  ${AuthorAvatarImage}, ${AuthorPlaceholder} {
    inline-size: 70px;
    block-size: 70px;
  }
  ${props => props.theme.breakpoints.up("tablet")} {
    ${AuthorAvatarImage}, ${AuthorPlaceholder} {
      inline-size: 100px;
      block-size: 100px;
    }
  }
`;

export const HeaderBarContainer = styled.div`
  grid-area: header-bar;
`;

export const FollowButtonContainer = styled.div`
  grid-area: follow-button;
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)``;

export const NameContainer = styled.div`
  grid-area: name;

  font-weight: 700;
`;

export const StyledAuthorName = styled(AuthorName)`
  line-height: 16px;
`;

export const BioContainer = styled.div`
  grid-area: bio;
`;

export const SocialLinksContainer = styled.div`
  grid-area: social;
`;

export const StyledAuthorSocialLinks = styled(AuthorSocialLinks)`
  margin-block-start: 12px;
`;

export const StyleAuthorCardContainer = styled.div`
  display: flex;

  inline-size: 295px;

  text-align: start;

  &:first-child {
    position: relative;

    border-block-start: 1px solid #222222;
    &::before {
      position: absolute;
      inset-inline-start: 0;
      content: " ";

      inline-size: 80px;
      block-size: 0;

      border-block-start: 4px solid #222222;
    }
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 582px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 660px;
  }
`;

export const StyleAuthorInfoContainer = styled.div`
  display: flex;
  flex-direction: column;

  padding-block-start: 32px;
`;

export const StyleAvatarContainer = styled.div`
  margin-inline-end: 20px;
  padding-block-start: 40px;

  ${AuthorAvatarImage}, ${AuthorPlaceholder} {
    inline-size: 80px;
    block-size: 80px;
  }

  ${AuthorAvatarImage} {
    filter: none !important;
  }
`;

export const StyleNameContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin-block-end: 12px;
`;

export const StyledStyleAuthorName = styled(AuthorName)`
  display: flex;
  align-items: center;

  margin-block-start: 8px;
  margin-block-end: 8px;
  margin-inline-end: 16px;

  font-weight: 700;
  font-size: 18px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: normal;
  letter-spacing: 0.9px;
  text-transform: uppercase;
`;
